import { TransportStatus, type Transport } from '~/types/transport'

export interface TransportActionHandlers {
    onView?: (transport: Transport) => void
    onEdit?: (transport: Transport) => void
    onViewInvoice?: (transport: Transport) => void
    onShare?: (transport: Transport) => void
    onResendEmail?: (transport: Transport) => void
    onCopyLink?: (transport: Transport) => void
    onAccept?: (transport: Transport) => void
    onDecline?: (transport: Transport) => void
    onComplete?: (transport: Transport) => void
    onCancel?: (transport: Transport) => void
}

export function useTransportActions() {
    function build(transport: Transport, h: TransportActionHandlers) {
        const primary: any[] = []
        const share: any[] = []
        const status: any[] = []
        const danger: any[] = []

        if (h.onView) {
            primary.push({ label: 'View Transport', icon: 'i-ph-ambulance-fill', click: () => h.onView!(transport) })
        }

        const isTerminal = transport.status === TransportStatus.completed || transport.status === TransportStatus.cancelled
        const isDeclined = transport.status === TransportStatus.declined

        if (!isTerminal && !isDeclined && h.onEdit) {
            primary.push({ label: 'Edit', icon: 'i-ph-pencil-fill', click: () => h.onEdit!(transport) })
        }

        if (transport.status === TransportStatus.completed && h.onViewInvoice) {
            primary.push({
                label: 'View Invoice',
                icon: 'i-ph-receipt-fill',
                disabled: !transport.invoice_id,
                click: () => transport.invoice_id && h.onViewInvoice!(transport),
            })
        }

        if (transport.status === TransportStatus.pending && h.onShare) {
            share.push({ label: 'Share with Provider', icon: 'i-ph-share-fat-fill', click: () => h.onShare!(transport) })
        }

        const sharedBefore = !!transport.shared_at
        const canResend = sharedBefore && (transport.status === TransportStatus.processing || transport.status === TransportStatus.accepted)
        if (canResend && h.onResendEmail) {
            share.push({ label: 'Resend Email', icon: 'i-ph-envelope-fill', click: () => h.onResendEmail!(transport) })
        }

        if (sharedBefore && h.onCopyLink) {
            share.push({ label: 'Copy Link', icon: 'i-ph-link-fill', click: () => h.onCopyLink!(transport) })
        }

        const canAccept = transport.status === TransportStatus.pending || transport.status === TransportStatus.processing
        if (canAccept && h.onAccept) {
            status.push({ label: 'Accepted', icon: 'i-ph-thumbs-up-fill', iconClass: 'text-violet-500', click: () => h.onAccept!(transport) })
        }
        if (canAccept && h.onDecline) {
            status.push({ label: 'Declined', icon: 'i-ph-thumbs-down-fill', iconClass: 'text-orange-500', click: () => h.onDecline!(transport) })
        }

        if (transport.status === TransportStatus.accepted && h.onComplete) {
            status.push({ label: 'Completed', icon: 'i-ph-check-circle-fill', iconClass: 'text-emerald-500', click: () => h.onComplete!(transport) })
        }

        if (!isTerminal && !isDeclined && h.onCancel) {
            danger.push({ label: 'Cancel Transport', icon: 'i-ph-x-circle-fill', iconClass: 'text-red-400', click: () => h.onCancel!(transport) })
        }

        return [primary, share, status, danger].filter(g => g.length)
    }

    return { build }
}
